const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	applications:null,
	application:null,
	steps:null,
	preApplicationItems :null,
	postDecisionRequirements : null,
	registrationItems : null,
	requestedAgainItems : null,
	courses:null,
	appliedBackupCourses:[]
}
const getters = {
	applicationsGetter:({applications}) => applications,
	applicationGetter:({application}) => application,
	stepsGetter:({steps}) => steps,
	preApplicationItemsGetter:({preApplicationItems}) => preApplicationItems,
	postDecisionRequirementsGetter:({postDecisionRequirements}) => postDecisionRequirements,
	registrationItemsGetter:({registrationItems}) => registrationItems,
	requestedAgainItemsGetter:({requestedAgainItems}) => requestedAgainItems,
	coursesGetter:({courses}) => courses,
	appliedBackupCoursesGetter:({appliedBackupCourses}) => appliedBackupCourses,
}

const mutations = {
	setApplications : (state,payload)=> state.applications = payload,
	setApplication : (state,payload)=> state.application = payload,
	setSteps : (state,payload)=> state.steps = payload,
	setPreApplicationItems : (state,payload)=> state.preApplicationItems = payload,
	setPostDecisionRequirements : (state,payload)=> state.postDecisionRequirements = payload,
	setRegistrationItems : (state,payload)=> state.registrationItems = payload,
	setRequestedAgainItems : (state,payload)=> state.requestedAgainItems = payload,
	setCourses : (state,payload)=> state.courses = payload,
	setAppliedBackupCourses : (state,payload)=> state.appliedBackupCourses = payload,
}

const actions = {
	// Okuma istekleri tam ekran #loading katmanını açmaz; bileşenler kendi skeleton'ını gösterir.
	async getApplications({commit}, payload){
		await this.$axios.get(`${BASE_API}/applications`).then(res => {
			commit('setApplications',res.data.result.data)
		})
	},
	async createApplication({commit}, payload){
		$('#loading').show();
		try {
			await this.$axios.post(`${BASE_API}/applications`, payload.data)
		} finally {
			$('#loading').hide();
		}
	},
	async getApplication({commit}, payload){
		return await this.$axios.get(`${BASE_API}/applications/${payload.applicationID}`).then(res => {
			commit('setApplication',res.data.result)
		})
	},
	async getSteps({commit}, payload){
		await this.$axios.get(`${BASE_API}/application-steps`).then(res => {
			commit('setSteps',res.data.result.data)
		})
	},
	async getApplicationItems({commit}, payload){
		await this.$axios.get(`${BASE_API}/applications/${payload.application.id}/items`).then(res => {
			let preApplicationItems = {}
			let postDecisionRequirements = {}
			let registrationItems = {}
			let requestedAgainItems = {}

			Object.keys(res.data.result).forEach(key => {
				preApplicationItems[key] = res.data.result[key].filter((item) => item.step.id === 1)
				postDecisionRequirements[key] =  res.data.result[key].filter((item) => item.step.id === 6)
				registrationItems[key] =  res.data.result[key].filter((item) => item.step.id === 8)
				requestedAgainItems[key] =  res.data.result[key].filter((item) => item.is_reupload === 1)
			})

			commit('setPreApplicationItems',preApplicationItems)
			commit('setPostDecisionRequirements',postDecisionRequirements)
			commit('setRegistrationItems',registrationItems)
			console.log('setRequestedAgainItems', requestedAgainItems)
			commit('setRequestedAgainItems',requestedAgainItems)
		})
	},
	async getCourses({commit}, payload){
		await this.$axios.get(`${BASE_API}/campuses/${payload.application.course.campus.slug}/courses`).then(res => {
			console.log('res', res.data.result)
			commit('setCourses',res.data.result)
		})
	},
	async updateApplication({commit}, payload){
		await this.$axios.put(`${BASE_API}/applications/${payload.data.applicationID}`, payload.data.fileData).then(res => {
			commit('setApplication',res.data.result)
		})
	},
	async addBackup({commit}, payload){
		if(state.appliedBackupCourses.length < 2){
			await this.$axios.post(`${BASE_API}/applications/${payload.data.applicationID}/backup-courses/${payload.data.courseID}`, payload.data.fileData).then(res => {
					let backupList =  state.backupCourses
					backupList.push(res.data.result)
					commit('setAppliedBackupCourses',backupList)
			})
		}
	},
	async getAppliedBackupCourses({commit}, payload){
		await this.$axios.get(`${BASE_API}/applications/${payload.application.id}/backup-courses`).then(res => {
			commit('setAppliedBackupCourses',res.data.result.data)
		})
	},
	async deleteItemFile({commit}, payload){
		await this.$axios.delete(`${BASE_API}/applications/${payload.application.applicationID}/items/${payload.application.itemID}`).then(res => {
			return res.data.success
		})
	}
}

export default {namespaced:true,state,getters,mutations,actions}
